<script>
import { v1 as uuid } from 'uuid';
import debounce from 'lodash/debounce';

export default {
  data() {
    return {
      contentHeight: 0,
      id: uuid(),
      isExpanded: false,
      isMobile: false,
    };
  },
  mounted() {
    this.update();
    window.addEventListener('resize', debounce(() => this.update(), 300));
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    update() {
      this.isMobile = window.innerWidth < 768;
      this.contentHeight = this.$refs.wysiwyg.offsetHeight;
    },
  },
};
</script>
